import { LoaderInterceptor } from './interceptors/loading.interceptor.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { MaterialModule } from '@ebw-monorepo/material';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [LoadingComponent],
  exports: [LoadingComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      // useFactory: (translate) => {
      //   const service = new LoaderInterceptor(new LoaderService, new EbwModalService);
      //   service.injectTranslateService(translate);
      //   return service;
      // },
      // deps: [TranslateService],
      useClass: LoaderInterceptor,
      multi: true
    }
  ]
})
export class LoadingModule {}
